<template>
  <div
    class="bg-white flex flex-col text-black card-rounded card-p clamp-gap-5-10 clamp-max-h-80-134 clamp-min-h-80-134 overflow-hidden"
  >
    <div class="flex flex-col clamp-gap-2-5">
      <span class="text-body-sm">{{ dateFormatted }}</span>
      <span class="text-body-md font-bold">{{ headlineText }}</span>
    </div>

    <div
      class="relative flex-1 overflow-hidden pointer-events-auto"
      :class="{
        'clamp-rounded-3-3 rounded-tl-0 rounded-tr-0': hasCoverImage,
      }"
    >
      <div
        v-if="hasCoverImage && coverImage?.image.filename"
        class="w-full relative clamp-rounded-3-3 pb-50% bg-skeleton skeleton-loading-image"
      >
        <AImage
          :src="coverImage.image.filename"
          :alt="coverImage.image.alt"
          :focalPoint="coverImage.image.focus"
          :ratio="{ w: 2, h: 1 }"
          class="absolute clamp-rounded-3-3 w-full"
        />
      </div>
      <ARichText
        v-if="!hasCoverImage"
        v-for="item in articleContent"
        :richtext="item.text"
        class="article-content w-full"
      />
      <div
        v-if="!hasCoverImage"
        class="fade-effect translate-y-1px absolute bottom-0 left-0 w-full clamp-h-20-30 pointer-events-none"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RichtextTextStoryblok, MediaImageStoryblok } from '@/types';
import { useFormattedDate } from '@/composables/useDateFormatting';

export interface CardTemplateProps {
  date: string;
  headlineText: string;
  articleContent: RichtextTextStoryblok[];
  coverImage?: MediaImageStoryblok;
}
const props = defineProps<CardTemplateProps>();

const hasCoverImage = computed(() => !!props.coverImage?.image.filename);
const dateFormatted = useFormattedDate(props.date);
</script>

<style scoped lang="scss">
.fade-effect {
  background: scrim-gradient(#fff, 'to top', 1);
}

.article-content {
  :deep(p) {
    @apply text-body-sm;
  }
  :deep(i) {
    @apply not-italic;
  }
}
</style>
